import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { view } from '@forge/bridge';

import '@atlaskit/css-reset';

import IncidentBannersIssueContext from './issueContext/components';
import { AppContext } from './issueContext/interfaces';
import { store } from './issueContext/store/store';
import IncidentBannersView from './pages/banners-view/IncidentBannersView';

void view.theme.enable();

const renderReactApp = (component: JSX.Element) => {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>{component}</Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

const renderApp = async () => {
    const context = (await view.getContext()) as AppContext;
    const { moduleKey } = await view.getContext();

    switch (moduleKey) {
        case 'incident-banners-portal-header':
            renderReactApp(<IncidentBannersView />);
            break;
        case 'incident-banners-issue-context':
            renderReactApp(<IncidentBannersIssueContext context={context} />);
            break;
        default:
            console.error('No handler for view');
    }
};

void renderApp();
